/* global LANG */
import React from 'react';
import { Router, Route, IndexRoute } from 'react-router';
import Cookies from 'js-cookie';

import App from './containers/App.jsx';
import Credits from './containers/Credits.jsx';
import scenesData from './data/scenes.json';

const forcedLanguage = typeof LANG !== 'undefined' ? LANG : null;

const routes = scenesData.map((scene, idx) => {
    const sceneName = scene.name;
    const sceneRoute = scene.route;
    const sceneLanguage = forcedLanguage || scene.language;
    const sceneIndex = scene.index === true;

    const Component = () => {
        if (sceneLanguage) {
            Cookies.set('language', sceneLanguage);
        }
        return <App sceneName={sceneName} language={sceneLanguage} />;
    };

    const CreditsComponent = () => {
        if (sceneLanguage) {
            Cookies.set('language', sceneLanguage);
        }
        return <Credits sceneName={sceneName} language={sceneLanguage} />;
    };

    if (sceneName === 'credits') {
        return <Route key={`${idx}-${sceneLanguage}-${sceneName}`} path={sceneRoute} component={CreditsComponent} />;
    }

    if (sceneIndex) {
        return <IndexRoute key={sceneName} component={Component} />;
    }
    return <Route key={`${idx}-${sceneLanguage}-${sceneName}`} path={sceneRoute} component={Component} />;
});

module.exports = (
    <Route path="/">
        { routes }
    </Route>
);



// WEBPACK FOOTER //
// ./js/routes.jsx